(() => {
  const emit = (name, detail = {}) => {
    const payload = { event: name, ...detail };
    window.dispatchEvent(new CustomEvent('meruzy:conversion', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  };

  document.addEventListener('click', (event) => {
    const page = event.target.closest('[data-product-page]');
    if (!page) return;
    const product = page.dataset.productPage;
    if (event.target.closest('.mz-procurement__actions .mz-procurement__button:not(.mz-procurement__button--secondary), .mz-procurement__quote .mz-procurement__button')) {
      emit('meruzy_estimate_cta_click', { product });
    } else if (event.target.closest('.mz-procurement__button--secondary')) {
      emit('meruzy_product_details_click', { product });
    } else if (event.target.closest('.mz-procurement__catalog a')) {
      emit('meruzy_catalog_interaction', { product });
    }
  });
})();
